<template>
  <Upload></Upload>
</template>
<script>
import Upload from '@/components/material-audio-upload';

export default {
  name: '',
  components: {
    Upload,
  },
};
</script>
